import { UserPersonalDataDto } from '@sr/dto';
import { userPersonalDataApi } from './api';

export const useGetUserPersonalData = (userId: number) => {
  const { data, isLoading, error } = userPersonalDataApi.useGetUserPersonalDataQuery(userId, { refetchOnMountOrArgChange: true });

  return { data, isLoading, error };
};

export const useUpdateUserPersonalData = (userId: number) => {
  const [updateData] = userPersonalDataApi.useUpdateUserPersonalDataMutation();
        
  return (data: UserPersonalDataDto) => updateData({ userId, data }).unwrap();
};
